import { type UiLibI18n } from '@myre/domain-i18n-wordings';

import { Component, computed, inject, input, output } from '@angular/core';
import { type FileUIPart } from 'ai';

import { WORDINGS } from '../../../myre-wordings-loader';

@Component({
  selector: 'app-file-attachment',
  standalone: true,
  templateUrl: './file-attachment.component.html',
  styleUrl: './file-attachment.component.scss',
})
export class FileAttachmentComponent {
  private readonly _wordings = inject<UiLibI18n>(WORDINGS);

  public readonly file = input.required<FileUIPart>();
  public readonly variant = input<string>('assistant');

  public readonly download = output<void>();

  protected get chatWordings() {
    return this._wordings._library.chat;
  }

  protected readonly fileName = computed(
    () => this.file().filename || this.chatWordings.attachment(),
  );

  /** MIME type and/or size metadata shown below the filename when available. */
  protected readonly fileMeta = computed<string | null>(() => {
    const mediaType = this.file().mediaType;

    if (!mediaType) {
      return null;
    }

    return mediaType;
  });
}
